var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    id: "Ellipse 7",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DAFD82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M7 20H31",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M19 8L31 20L19 32",
    stroke: "black",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/slider-arrow.2c358495f1d4b13501a9515a94570d7d.svg";
export { ForwardRef as ReactComponent };